import React from 'react';
import {
  buttonStylesForProjects,
  defaultCommandBarButtonStyles,
  titleCommandBarButtonStyles,
} from '../../../../../styles/button-styles';
import ViewWrapperWithCommandBar from '../../../../Common/Layout/ViewWrapperWithCommandBar';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import {
  Text,
  DefaultPalette,
  Icon,
  Stack,
  TextField,
  ActionButton,
  DetailsList,
  SelectionMode,
} from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../../../common/routes';
import SystemClient from '../../../../../system/SystemClient';
import MessageCourier from '../../../../../lib/MessageCourier';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import useAsyncDataCourier from '../../../../../common/custom-hooks/useAsyncDataCourier';
import { DefaultButton, Label, Pivot, PivotItem, PrimaryButton } from '@fluentui/react';
import PlanillaPartidoForm from '../../../PlanillaPartidoForm';
import { CampoJuegoSelectorInput } from '../../../../CampoJuego/CampoJuegoSelector';
import { useCustomInput } from '../../../../../common/custom-hooks/useCustomInput';
import { Partido } from '../../../../../system/Partido/Partido';
import CustomInputIfc from '../../../../../lib/FormValidator/Form/CustomInputIfc';
import { DatePickerInput } from '../../../../../lib/FormValidator/Form/DatePickerInput';
import { HourSelector } from '../../../../Common/HourSelector';
import { ArbitroSelectorInput } from '../../../../Arbitro/ArbitroSelector_old';
import { PlanillaPartidoContext } from '../../../../../system/PlanillaPartido/PlanillaPartidoSystem';
import { Equipo } from '../../../../../system/Equipo/Equipo';
import { Jugador } from '../../../../../system/Jugador/Jugador';
import { Entrenador } from '../../../../../system/Entrenador/Entrenador';
import { PlanillaPartidoJugador } from '../../../../../system/PlanillaPartidoJugador/PlanillaPartidoJugador';
import { JugadorSelector } from '../../../../Jugador/JugadorSelector';
import { JugadorXEquipo } from '../../../../../system/JugadorXEquipo/JugadorXEquipo';
import { EntrenadorSelector } from '../../../../Entrenador/EntrenadorSelector';
import { PlanillaPartidoOficialAuxiliar } from '../../../../../system/PlanillaPartidoOficialAuxiliar/PlanillaPartidoOficialAuxiliar';
import { PlanillaPartidoOficial } from '../../../../../system/PlanillaPartidoOficial/PlanillaPartidoOficial';
import { useContainerStyle } from '../../../../../common/custom-hooks/useStyles';

export const EntrenadorCardForConfeccion = ({
  entrenador,
  system,
  deleteEntrenador,
}: {
  entrenador: Entrenador;
  system: SystemClient;
  deleteEntrenador: (e: Entrenador) => void;
}) => {
  const imgStackStyles = {
    root: {
      marginRight: '15px',
    },
  };
  const containerStyle = useContainerStyle();

  return (
    <div className="ms-Grid-col ms-sm12 mt-2" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div className="ms-Grid " style={containerStyle}>
        <div className={'ms-Grid-row mt-1'} style={{ padding: '3px', margin: '0.2rem' }}>
          <Stack horizontal>
            <Stack.Item styles={imgStackStyles}>
              {entrenador.getFoto() ? (
                <Image
                  src={system.getJugadorSystem().getUrlForImage(entrenador.getFoto())}
                  imageFit={ImageFit.cover}
                  maximizeFrame
                  styles={{
                    root: {
                      margin: '0 auto',
                      borderRadius: '50%',
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                    },
                  }}
                  className="player-card-img"
                />
              ) : (
                <Image
                  src={'/img/persona_default.jpg'}
                  imageFit={ImageFit.cover}
                  maximizeFrame
                  className="player-card-img"
                  styles={{
                    root: {
                      margin: '0 auto',
                      borderRadius: '50%',
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                    },
                  }}
                />
              )}
            </Stack.Item>

            <Stack.Item grow>
              <Text variant="mediumPlus" className="bold" block>
                {entrenador.getApellido()}, {entrenador.getNombre()}
              </Text>
              {entrenador.getDocumentoNumero() && (
                <>
                  <Text variant="small" className="secondary-text">
                    {+entrenador.getDtid() === 1 ? 'DNI: ' : 'Pasaporte: '}
                  </Text>{' '}
                  <Text variant="small" className="secondary-text">
                    {entrenador.getDocumentoNumero()}
                  </Text>
                </>
              )}
            </Stack.Item>
            <Stack.Item>
              <Icon
                iconName="Cancel"
                className="remove-item-cross clickable"
                onClick={() => {
                  deleteEntrenador(entrenador);
                }}
              ></Icon>
            </Stack.Item>
          </Stack>
        </div>
      </div>
    </div>
  );
};
